import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  children,
  onClick,
  ...props
}: ButtonProps) {
  const variants = {
    primary: cn('relative overflow-hidden', 'bg-gradient-to-r from-[#14b8a6] via-[#2dd4bf] to-[#14b8a6] bg-[length:200%_100%]', 'text-black font-black tracking-wide', 'btn-shimmer btn-pulse-glow', 'hover:bg-[position:100%_0]', 'border border-[#2dd4bf]/20', 'shadow-[0_4px_30px_rgba(20,184,166,0.2)]'),
    secondary: cn('relative overflow-hidden', 'bg-gradient-to-r from-[#06b6d4] via-[#22d3ee] to-[#06b6d4] bg-[length:200%_100%]', 'text-black font-black tracking-wide', 'btn-shimmer', 'shadow-[0_4px_30px_rgba(6,182,212,0.25)]', 'hover:shadow-[0_4px_40px_rgba(6,182,212,0.4)]', 'border border-[#22d3ee]/20'),
    outline: cn('border border-white/10 text-white bg-white/[0.03]', 'backdrop-blur-sm', 'hover:border-[#14b8a6]/50 hover:text-[#14b8a6]', 'hover:shadow-[0_0_30px_rgba(20,184,166,0.15)]', 'hover:bg-[#14b8a6]/[0.05]')
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-sm rounded-xl',
    md: 'px-7 py-3.5 text-base rounded-xl',
    lg: 'px-10 py-5 text-lg uppercase rounded-2xl'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e as any);
    } else {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.03,
    transition: {
      duration: 0.25,
      ease: 'easeOut'
    }
  }} whileTap={{
    scale: 0.97,
    transition: {
      duration: 0.1
    }
  }} onClick={handleClick} className={cn('transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer', variants[variant], sizes[size], className)} {...props} data-id="element-352">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-353">
        {children}
      </span>
    </motion.button>;
}